import * as React from 'react'

import { Tooltip } from 'embed/components/Tooltip'

const Info = require('assets/components/info-grey.svg')

const styles = require('./styles.scss')

const tooltipOverlayContent = (
  <div>
    <div>
      <strong>What is LeapLife?</strong>
    </div>
    <p>
      LeapLife and Fiona are owned and operated by Even Financial. Even is the leading search, comparison and
      recommendation engine for financial services. Even, Fiona and LeapLife work together to bring you personalized
      life insurance policy quotes. Learn more about Even at{' '}
      <a href="https://evenfinancial.com" target="_blank">
        EvenFinancial.com
      </a>{' '}
      and LeapLife at{' '}
      <a href="https://leaplife.com" target="_blank">
        LeapLife.com
      </a>{' '}
      and Fiona at{' '}
      <a href="https://fiona.com" target="_blank">
        Fiona.com
      </a>
      .
    </p>
  </div>
)

export const LeapLifeLogo = () => (
  <div className={styles.leapLife}>
    <img
      className={styles.logo}
      src="https://images.evenfinancial.com/logos/leaplife/leap-logo-green.svg"
      alt="LeapLife"
    />
    <Tooltip
      overlay={tooltipOverlayContent}
      overlayStyle={{ maxWidth: '400px' }}
      placement="top"
      trigger={['hover', 'click']}
    >
      <span className={styles.info}>
        <Info />
      </span>
    </Tooltip>
  </div>
)
